module.exports = __webpack_public_path__ + "catalog/items/bathroom/Bath-With-Large-Shower-Area/Bath-With-Large-Shower-Area.svg";